import React from 'react'
import StatusBadge from "../StatusBadge/StatusBadge"

const StatusCell = ({ props }) => {
  const status = props?.row.status
  return (
    <StatusBadge
      label={status?.label || ''}
      bgColor={status?.bgColor}
      textColor={status?.textColor}
    />
  )
}

export default StatusCell
